// https://developers.heap.io/reference

// Import Analytics type from ring-web-analytics
import { Analytics } from '@amzn/ring-web-analytics';

export interface Heap {
  addEventProperties: (properties: Record<string, unknown>) => void;
  addUserProperties: (properties: Record<string, unknown>) => void;
  appid: string;
  clearEventProperties: () => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  config: any;
  identify: (identity: string) => void;
  identity: string | null;
  load: (appId: string, properties?: Record<string, unknown>) => void;
  loaded: boolean;
  removeEventProperty: (property: string) => void;
  resetIdentity: () => void;
  track: (event: string, properties?: Record<string, unknown>) => void;
  userId: string;
}

// RingWebAnalytics types
export interface RWACustomDimensions {
  locale: string;
  productName?: string;
}

export interface RWAEventInfo {
  id?: string;
  type?: string;
  title?: string;
  properties?: Record<string, unknown>;
}

// Use the actual Analytics type from the library
export type RWAAnalytics<T = RWACustomDimensions> = Analytics<T>;

declare global {
  interface Window {
    heap: Heap;
    RWA: RWAAnalytics<RWACustomDimensions>;
  }
}

window.heap = window.heap || {};
